// extracted by mini-css-extract-plugin
export var bodyRow = "_fb-d";
export var cardColumns = "_fb-e";
export var ellipsesOverflow = "_fb-2";
export var flatBottomCorners = "_fb-3";
export var flatTopCorners = "_fb-4";
export var headerActionsDropdown = "_fb-f";
export var headerBottomRow = "_fb-c";
export var headerTopRow = "_fb-b";
export var orderDetailsWrapper = "_fb-0";
export var orderInfoContainer = "_fb-1";
export var productDetails = "_fb-9";
export var productImage = "_fb-5";
export var responsiveTable = "_fb-8";
export var shipmentContainer = "_fb-a";
export var tableBottomLeft = "_fb-6";
export var tableBottomRight = "_fb-7";